import { ErrorComponent } from './error/error.component';
import { LogoutComponent } from './session/logout/logout.component';
import { StartSessionComponent } from './session/start-session/start-session.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, Route, Router, Scroll, NavigationStart, NavigationEnd } from '@angular/router';
import { baseRouteConfig } from './base/base-route-config';
import { AfterLoginComponent } from './session/after-login/after-login.component';
import { AuthGuard } from './session/auth.guard';
import { ViewportScroller } from '@angular/common';
import { filter, tap } from 'rxjs/operators';


const indexRoute: Route = {
	path: '',
	redirectTo: '/principal/inicio',
	pathMatch: 'full'
};

const fallbackRoute: Route = {
	path: '**',
	redirectTo: '/principal/inicio'
}

const sessionRoute: Route = {
	path: 'sesion',
	children: [
		{
			path: 'login',
			component: AfterLoginComponent
		},
		{
			path: 'inicio',
			component: StartSessionComponent
		},
		{
			path: 'logout',
			component: LogoutComponent
		}
	]
};

const mainComponentsRoute: Routes = [
	{
		path: '',
		canActivateChild: [ AuthGuard ],
		children: [
			{
				path: '',
				children: baseRouteConfig,
			},
			{
				path: '',
				loadChildren: () => import('./legacy-site/legacy-site.module').then( mod => mod.LegacySiteModule ),
			},
			{
				path: 'perfil',
				loadChildren: () => import('./mi-perfil/mi-perfil.module').then( mod => mod.MiPerfilModule ),
				data: {
					breadcrumb: {
						label: 'Mi Perfil',
						link: false
					}
				}
			},
			// Beneficio Detalle
			// {
			// 	path: 'detalle',
			// 	loadChildren: () => import('./detalle/detalle.module').then( mod => mod.DetalleModule ),
			// 	data: {
			// 		breadcrumb: {
			// 			label: 'Detalle',
			// 			link: false
			// 		}
			// 	}
			// },
			{
				path: 'recursos',
				loadChildren: () => import('./contenido-seccion/contenido-seccion.module').then( mod => mod.ContenidoSeccionModule )
			},
			{
				path: 'recursos',
				loadChildren: () => import('./contenido-tree/contenido-tree.module').then( mod => mod.ContenidoTreeModule )
			}
		],
	}
];


const routes: Routes = [
	indexRoute,
	sessionRoute,
	{
		path: '',
		canActivateChild: [ AuthGuard ],
		children: mainComponentsRoute,
		data: {
			breadcrumb: {
				label: 'Comunità'
			}
		}
	},
	{
		path: 'error',
		component: ErrorComponent
	},
	fallbackRoute
];


@NgModule({
	imports: [ RouterModule.forRoot( routes, { scrollPositionRestoration: 'enabled' } ) ],
	exports: [ RouterModule ],
})
export class AppRoutingModule {

	// Workaround
	// Esta es una solución de compromiso al problema que tiene Angular dado que luego de
	// hacer un cambio de componente en varios casos no realiza un scroll to top.
	// "Angular Changing route doesn't scroll to top in the new page"
	constructor( router: Router ) {
		router.events.pipe(
			filter( (event) => event instanceof Scroll  ),
			tap( (event: Scroll) => {
				if( !event.position )
					setTimeout( () => window.scroll( 0, 0 ), 0 );
			})
		).subscribe();
	}

}